
<ng-container *ngIf="isLoaded">
  <div class="modal-close-btn" (click)="closeModal()">X</div>
  <div class="card mb-3">
    <div class="card-body">
      <div class="pt-4 pb-2">
        <h5 class="card-title text-center pb-0 fs-4">Създаване на Услуга</h5>
        <p class="text-center small">Моля, въведете основните данни на Услугата</p>
      </div>

      <form [formGroup]="Form" class="row g-3 needs-validation" (ngSubmit)="onSubmit()">
        <div class="col-12">
          <label for="serviceName" class="form-label">Тип</label>
          <input type="text" formControlName="serviceName" class="form-control" id="serviceName">
        </div>
        <div class="col-12">
          <label for="uri" class="form-label">Уеб Адрес</label>
          <input type="text" formControlName="uri" class="form-control" id="uri">
        </div>
        <div class="col-12">
          <label for="yri" class="form-label">УРИ</label>
          <input type="text" formControlName="yri" class="form-control" id="yri">
        </div>
        <div class="col-12">
          <div class="form-check">
            <input class="form-check-input" type="checkbox" formControlName="isActive" id="isActive">
            <label class="form-check-label" for="isActive">Активна</label>
          </div>
        </div>
        <div class="col-12">
          <button class="btn btn-primary w-100" type="submit" [disabled]="!Form.valid">Създай</button>
        </div>
      </form>
    </div>
  </div>

</ng-container>
